import { createRouter, createWebHashHistory } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import storage from '@/utils/storage'
import userAgent from '@/utils/ua-parser'
import langUtils from '@/lang/utils'
import store from '@/store/index.js'
import { KEY_USER_INFO, DEV } from '@/api/config'

import routes from './modules' // 路由业务逻辑模块

// 是否APP环境
const isApp = userAgent.isApp()

// 设置主体
const setWindowTheme = (skin)=>{
  storage.set('theme', skin)
  store.commit('viewLoad/SET_THEME', skin)
  // 设置主题
  setTimeout(()=>{
    console.log('setWindowTheme skin-',skin)
    let themeLinks = document.getElementsByClassName('theme-set')
    for(let item of themeLinks){
      item.disabled = true
      item.disabled = item.title != skin
    }
  },0)
}

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // let title = to.meta.title
  // document.title = title
  store.commit('viewLoad/updateLoadingStatus', { isLoading: true })
  // 白名单
  if (to.matched.some(res => res.meta.whiteAuth)) {
    next()
  }else if (isApp) {
    // // APP环境直接获取用户信息 -- 不存缓存
    window.JFSTOCK.getUserInfoAPP({
      success: (res) => {
        // 并修改手机字段统一为 --> phoneNum
        const result = JSON.parse(res.data)
        const { phoneNumber: phoneNum, language, skin = "white" } = result
        langUtils.toggleAlias(language)
        try{
          setWindowTheme(skin) // 设置主题
        }catch(error){
          console.log('setwindowTheme has error', error)
        }
        store.dispatch('user/appLogin', { ...result, phoneNum })
          .then(() => {
            next()
          })
      }
    })
  } else {
    langUtils.toggle(to.params.lang)
    try{
      // setWindowTheme('black') // 设置主题
      setWindowTheme('white') // 设置主题
    }catch(error){
      console.log('setwindowTheme has error', error)
    }
    // 白名单
    if (to.matched.some(res => res.meta.whiteAuth)) {
      next()
    } else {
      // 用户信息
      const userInfo = storage.get(KEY_USER_INFO)
      if (userInfo) {
        // 检测用户信息是否失效
        store.dispatch('user/checkLogin')
          .then(() => {
            next()
          })
          .catch(() => {
            store.dispatch('user/fedLogout').then(() => {
              location.reload()
            })
          })
      } else {
        // 跳转到登录界面
        store.commit('viewLoad/updateLoadingStatus', { isLoading: false })
        // 根据编译环境区分是否调用本项目内登录注册模块
        if (DEV) {
          NProgress.start()
          next({
            name: 'login',
            query: { redirect: to.fullPath },
            replace: true
          })
        } else {
          const url = window.location.href.split('#')[0]
          const redirect_url = encodeURIComponent(url)
          window.location.href = window.USER_CENTER + `?redirect_url=${redirect_url}`
        }
      }
    }
  }
})

router.afterEach(() => {
  store.commit('viewLoad/updateLoadingStatus', { isLoading: false })
  NProgress.done()
})

export default router
